module.exports = __webpack_public_path__ + "static/media/grid.fb6df033.svg";